import * as React from 'react';
import { UserEventTracker } from '../lib/UserEventTracker';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const TrackerContext = React.createContext({
  tracker: new UserEventTracker()
});
export const TrackerProvider = _ref => {
  let {
    children,
    userId
  } = _ref;
  const [tracker, setTracker] = React.useState();
  React.useEffect(() => setTracker(new UserEventTracker(userId)), [userId]);
  if (tracker === undefined) {
    return ___EmotionJSX(React.Fragment, null, children);
  }
  return ___EmotionJSX(TrackerContext.Provider, {
    value: {
      tracker
    }
  }, children);
};